import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0","key":"svg-0"}],["path",{"d":"M9 15l6 -6","key":"svg-1"}]]

const IconForbid2 = createReactComponent('outline', 'forbid-2', 'Forbid2', __iconNode);

export default IconForbid2;